module.exports = __webpack_public_path__ + "static/media/light-blue-dot.047ebbb5.svg";